var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mb-5",attrs:{"fluid":""}},[_c('DashboardComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }